import { render } from "./NewPasswordNew.vue?vue&type=template&id=0504b3a9&scoped=true"
import script from "./NewPasswordNew.vue?vue&type=script&lang=js"
export * from "./NewPasswordNew.vue?vue&type=script&lang=js"

import "./NewPasswordNew.vue?vue&type=style&index=0&id=0504b3a9&lang=scss&scoped=true"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0504b3a9"]])

export default __exports__